module.exports = __webpack_public_path__ + "static/media/IMG_0467_Reduced.b28cdb7c.jpg";